import { imgproxySettings, mobileImgproxySettings } from './shared.mjs'
import { background } from './tempests.mjs'

export const body = {
  id: 'body',
  name: 'Body',
  imgproxySettings,
  mobileImgproxySettings,
  hasOptions: false,
  pathTemplate: 'gs://sg360/220704/tempests-le_sailgp/tesmpests-le_sailgp_{nnn}.png',
}

export default {
  layers: [background, body],
  resolveOptions: () => ({}),
}
